import { RouteID } from '../../types/features/navigation/navigation-types';
import { RoutesConfig } from '../../types/features/navigation/routes-config-types';

const routesConfig: RoutesConfig = [
  {
    id: RouteID.ROOT,
    handler: {},
  },
  {
    id: RouteID.LOGIN,
    handler: {},
  },
  {
    id: RouteID.REGISTER,
    handler: {},
  },
  {
    id: RouteID.REGISTER_EMAIL,
    handler: {},
  },
  {
    id: RouteID.REGISTER_PHONE,
    handler: {},
  },
  {
    id: RouteID.REGISTER_PHONE_PARAM,
    handler: {
      paramsParser: ({ data }) => ({
        phone: data?.phone,
      }),
    },
    pathBuilder: params => {
      const phone = params?.phone ?? '';
      return RouteID.REGISTER_PHONE_PARAM.replace(':phone', phone) as RoutePath;
    },
  },
  {
    id: RouteID.RECOVERY,
    handler: {},
  },
  {
    id: RouteID.RECOVERY_RESET,
    handler: {
      paramsParser: ({ queryString }) => ({
        resetPasswordToken: queryString?.reset_password_token,
        recoveryEmail: queryString?.email,
      }),
    },
  },
  {
    id: RouteID.INVITATIONS,
    handler: {
      paramsParser: ({ queryString }) => ({
        invitationToken: queryString?.confirmation_token ?? queryString?.invitation_token,
        invitationEmail: queryString?.email,
      }),
    },
  },
  {
    id: RouteID.TEMPORARY_SIGN_IN,
    handler: {
      paramsParser: ({ data }) => ({
        token: data?.token,
      }),
    },
    pathBuilder: params => {
      const token = params?.token ?? '';
      return RouteID.TEMPORARY_SIGN_IN.replace(':token', token) as RoutePath;
    },
  },
  {
    id: RouteID.NOT_FOUND,
    handler: {},
  },
];

export { routesConfig };
